import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useNoticeModel } from "./summaryModel";
import { DetailDrawer } from "./DetailDrawer";

export function Notice() {
    const {
        loadData,
        resetState,
        getDs,
    } = useNoticeModel()
    useEffect(() => {
        getDs()
        loadData({ pageNum: 1 }, {}).then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

